import { Injectable } from '@angular/core';
import { concat, Observable } from 'rxjs';
import { first, tap } from 'rxjs/operators';

import { CountryApiRepository } from '../repositories/country-api.repository';
import { CountryCacheRepository } from '../repositories/country-cache.repository';
import { CountryInterface } from '../data';
import { Transaction } from '../transaction/transaction';

@Injectable()
export class CountryProvider {
    constructor(private countryApiRepository: CountryApiRepository, private countryCacheRepository: CountryCacheRepository) {}

    find(): Observable<Transaction<CountryInterface[]>> {
        return concat(
            this.countryCacheRepository.load(),
            this.countryApiRepository.load().pipe(
                tap((transaction) => {
                    if (transaction.isSuccess) {
                        this.countryCacheRepository.save(transaction.data).subscribe();
                    }
                })
            )
        ).pipe(first());
    }
}
